export const downloadBlob = (blob: Blob, filename: string) => {
  // Create a temporary link element
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  // Set the link properties
  link.href = url;
  link.download = filename;

  // Trigger a click on the link
  document.body.appendChild(link); // Append link to the body
  link.click();
  document.body.removeChild(link); // Clean up the link element

  // Release the object URL
  URL.revokeObjectURL(url);
};
